import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['realNameFields', 'nicknameField', 'toggle']

  toggle () {
    this.updateVisibility()
  }

  updateVisibility () {
    const isChecked = this.toggleTarget.checked

    if (isChecked) {
      // Hide real name fields, show nickname field
      this.realNameFieldsTarget.classList.add('hidden')
      this.nicknameFieldTarget.classList.remove('hidden')
    } else {
      // Show real name fields, hide nickname field
      this.realNameFieldsTarget.classList.remove('hidden')
      this.nicknameFieldTarget.classList.add('hidden')
    }
  }
}
